(function () {
  function init(root) {
    if (!root || root.dataset.snReady === 'true') return;
    root.dataset.snReady = 'true';

    var timerWrap = root.querySelector('[data-timer-wrap]');
    var timerBoxes = root.querySelector('[data-timer-boxes]');
    var timerEnded = root.querySelector('[data-timer-ended]');
    var formState = root.querySelector('[data-form-state]');
    var successState = root.querySelector('[data-success-state]');
    var form = root.querySelector('[data-notify-form]');
    var emailInput = root.querySelector('[data-notify-email]');
    var submitBtn = root.querySelector('[data-notify-submit]');
    var errorEl = root.querySelector('[data-notify-error]');
    var successEmailEl = root.querySelector('[data-success-email]');

    var endpoint = root.dataset.sheetEndpoint || '';
    var sourceTag = root.dataset.sourceTag || '';
    var storageKey = root.dataset.storageKey || '';

    function pad(n) {
      n = Math.floor(n);
      return n < 10 ? '0' + n : String(n);
    }

    function showSuccess(email) {
      if (successEmailEl) successEmailEl.textContent = email || '';
      if (formState) formState.hidden = true;
      if (successState) successState.hidden = false;
    }

    // Countdown
    if (timerWrap) {
      var dateStr = root.dataset.saleDate || '';
      var timeStr = root.dataset.saleTime || '00:00';
      var tz = root.dataset.tzOffset || '+00:00';
      var hideOnEnd = root.dataset.hideTimerOnEnd === 'true';
      var target = NaN;

      if (dateStr) {
        target = new Date(dateStr + 'T' + timeStr + ':00' + tz).getTime();
      }

      if (isNaN(target)) {
        timerWrap.hidden = true;
      } else {
        var digits = {
          days: root.querySelector('[data-unit="days"]'),
          hours: root.querySelector('[data-unit="hours"]'),
          mins: root.querySelector('[data-unit="mins"]'),
          secs: root.querySelector('[data-unit="secs"]')
        };

        var tick = function () {
          var diff = target - Date.now();
          if (diff <= 0) {
            clearInterval(intervalId);
            if (hideOnEnd) {
              timerWrap.hidden = true;
            } else if (timerBoxes && timerEnded) {
              timerBoxes.hidden = true;
              timerEnded.hidden = false;
            }
            return;
          }
          var days = diff / 86400000;
          var hours = (diff % 86400000) / 3600000;
          var mins = (diff % 3600000) / 60000;
          var secs = (diff % 60000) / 1000;
          if (digits.days) digits.days.textContent = pad(days);
          if (digits.hours) digits.hours.textContent = pad(hours);
          if (digits.mins) digits.mins.textContent = pad(mins);
          if (digits.secs) digits.secs.textContent = pad(secs);
        };

        tick();
        var intervalId = setInterval(tick, 1000);
      }
    }

    // Restore a prior successful signup on this device
    try {
      var stored = storageKey ? window.localStorage.getItem(storageKey) : null;
      if (stored) showSuccess(stored);
    } catch (e) {}

    if (!endpoint && window.Shopify && window.Shopify.designMode) {
      console.warn('[sale-notify] No Google Sheet endpoint configured for section "' + root.id + '".');
    }

    if (form) {
      form.addEventListener('submit', function (evt) {
        evt.preventDefault();
        if (errorEl) errorEl.hidden = true;

        if (!emailInput || !emailInput.checkValidity()) {
          if (emailInput) emailInput.reportValidity();
          return;
        }

        var email = emailInput.value.trim();

        if (!endpoint) {
          try {
            if (storageKey) window.localStorage.setItem(storageKey, email);
          } catch (e) {}
          showSuccess(email);
          return;
        }

        if (submitBtn) submitBtn.disabled = true;

        var body = new URLSearchParams({
          email: email,
          source: sourceTag,
          page: window.location.href,
          timestamp: new Date().toISOString()
        });

        fetch(endpoint, {
          method: 'POST',
          mode: 'no-cors',
          body: body
        })
          .then(function () {
            try {
              if (storageKey) window.localStorage.setItem(storageKey, email);
            } catch (e) {}
            showSuccess(email);
          })
          .catch(function () {
            if (errorEl) errorEl.hidden = false;
          })
          .finally(function () {
            if (submitBtn) submitBtn.disabled = false;
          });
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-sale-notify]').forEach(init);
  }

  domReady(initAll);

  document.addEventListener('shopify:section:load', function (evt) {
    var el = evt.target.querySelector ? evt.target.querySelector('[data-sale-notify]') : null;
    if (el) init(el);
  });
})();
